import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
 .then(() => {
    const script = document.createElement('script');
    script.type = "javascript";
    script.src = 'assets/scripts.js';
    script.defer = true;
    document.body.appendChild(script);
  })
  .catch(err => console.error(err));
